<template>
    <div class="container mx-auto">
        <div  class="mx-auto" v-if="editor">
            <button class="btn-markdown font-bold" @click="editor.chain().focus().toggleBold().run()" :class="{ 'btn-markdown-is-active': editor.isActive('bold') }">
                B
            </button>
            <button class="btn-markdown italic" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'btn-markdown-is-active': editor.isActive('italic') }">
                I
            </button>
            <button class="btn-markdown line-through" @click="editor.chain().focus().toggleStrike().run()" :class="{ 'btn-markdown-is-active': editor.isActive('strike') }">
                S
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'btn-markdown-is-active': editor.isActive('heading', { level: 1 }) }">
                H1
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'btn-markdown-is-active': editor.isActive('heading', { level: 2 }) }">
                H2
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'btn-markdown-is-active': editor.isActive('heading', { level: 3 }) }">
                H3
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().toggleHeading({ level: 4 }).run()" :class="{ 'btn-markdown-is-active': editor.isActive('heading', { level: 4 }) }">
                H4
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'btn-markdown-is-active': editor.isActive('bulletList') }">
                <svg class="h-4 w-4"
                     height="512" viewBox="0 0 32 32" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_2" data-name="Layer 2"><path d="m28 4h-16a2 2 0 0 0 0 4h16a2 2 0 0 0 0-4z"/><circle cx="4" cy="6" r="2"/><path d="m28 14h-16a2 2 0 0 0 0 4h16a2 2 0 0 0 0-4z"/><circle cx="4" cy="16" r="2"/><path d="m28 24h-16a2 2 0 0 0 0 4h16a2 2 0 0 0 0-4z"/><circle cx="4" cy="26" r="2"/></g></svg>
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'btn-markdown-is-active': editor.isActive('orderedList') }">
                <svg class="h-4 w-4" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m256 6c-138.071 0-250 111.929-250 250s111.929 250 250 250 250-111.929 250-250-111.929-250-250-250zm52.075 374.689h-67.182v-192.865h-36.968v-56.513h104.15z"/></svg>            </button>
            <button class="btn-markdown" @click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'btn-markdown-is-active': editor.isActive('blockquote') }">
                <svg class="h-4 w-4" enable-background="new 0 0 409.294 409.294" height="512" viewBox="0 0 409.294 409.294" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m0 204.647v175.412h175.412v-175.412h-116.941c0-64.48 52.461-116.941 116.941-116.941v-58.471c-96.728 0-175.412 78.684-175.412 175.412z"/><path d="m409.294 87.706v-58.471c-96.728 0-175.412 78.684-175.412 175.412v175.412h175.412v-175.412h-116.941c0-64.48 52.461-116.941 116.941-116.941z"/></svg>
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().setHorizontalRule().run()">
                -
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().setHardBreak().run()">
                +
            </button>
            <button class="btn-markdown inline-flex p-2 align-middle" @click="editor.chain().focus().undo().run()">
                <svg class="h-4 w-4" id="icons" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m6.3 14.71a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.3 1 1 0 0 0 0-1.41l-3.35-3.29h6.64a8 8 0 0 1 8 8v2a1 1 0 0 0 2 0v-2a10 10 0 0 0 -10-10h-6.62l3.32-3.29a1 1 0 0 0 -1.4-1.42l-5.07 5a1 1 0 0 0 0 1.42z"/></svg>
            </button>
            <button class="btn-markdown" @click="editor.chain().focus().redo().run()">
                <svg class="h-4 w-4 flip" id="icons" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m6.3 14.71a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.3 1 1 0 0 0 0-1.41l-3.35-3.29h6.64a8 8 0 0 1 8 8v2a1 1 0 0 0 2 0v-2a10 10 0 0 0 -10-10h-6.62l3.32-3.29a1 1 0 0 0 -1.4-1.42l-5.07 5a1 1 0 0 0 0 1.42z"/></svg>
            </button>
            <button class="btn-markdown">
                <label for="img">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd" /></svg>
                </label>
            </button>
            <input type="file" id="img" class="w-px h-px opacity-0 overflow-hidden absolute" @change="addImage" ref="file" />
        </div>
        <editor-content :editor="editor" />
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-3'
import { StarterKit } from '@tiptap/starter-kit'
import Image from '@tiptap/extension-image'
import {Heading} from "@tiptap/extension-heading";
import Label from "@/Jetstream/Label";
import Button from "@/Jetstream/Button";
import axios from 'axios';

export default {
    components: {
        Button,
        Label,
        EditorContent,
    },
    model: {
        prop: 'content',
        event: 'input'
    },
    props: ['modelValue'],
    emits: ['update:modelValue'],
    data() {
        return {
            editor: null,
            html: this.modelValue
        }
    },
    methods: {
        save: function() {
            console.log(this.editor.getHTML());
        },
        update: function () {
            this.html = this.editor.getHTML()
            this.$emit('update:modelValue', this.html)
            console.log("emmitedd")
        },
        async addImage(event) {
            console.log(event.target.files);
            var data = new FormData();
            var uri = null;
            data.append('img', event.target.files[0] || '')

            axios.post(route('email.img.new'), data)
            .then(x => {
                this.editor.chain().focus().setImage({ src: x.data }).run()
            })
        },
    },
    mounted() {
        this.editor = new Editor({
            extensions: [
                StarterKit,
                Heading.configure({
                    HTMLAttributes: {
                        addClass: '!mb-0',
                    },
                }),
                Image,
            ],
            editorProps: {
                attributes: {
                    class:
                        "prose prose-sm sm:prose lg:prose-lg xl:prose-2xl m-5 focus:outline-none"
                }
            },
            content: this.modelValue,
        })
        this.editor.on('update', this.update)
    },

    beforeDestroy() {
        this.editor.destroy()
    },
}
</script>
